import { render, staticRenderFns } from "./SacConfigRubro.vue?vue&type=template&id=6c81cc05"
import script from "./SacConfigRubro.vue?vue&type=script&lang=js"
export * from "./SacConfigRubro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports